import React from 'react';

const AboutUs = () => {
    const styles = {
        container: {
            padding: '80px 20px',
        },
        flexContainer: {
            display: 'flex',
            gap: '60px',
            alignItems: 'center',
            maxWidth: '1100px',
            margin: '0 auto',
            // Responsive flex direction for smaller screens
            flexDirection: window.innerWidth < 768 ? 'column' : 'row'
        },
        imageSide: {
            flex: '1',
            width: '100%' // Ensures it takes full width on mobile
        },
        // New style for the actual image
        image: {
            width: '100%',
            height: 'auto',
            borderRadius: '12px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
            objectFit: 'cover'
        },
        contentSide: {
            flex: '1.5',
            width: '100%' // Ensures it takes full width on mobile
        },
        h1: {
            fontSize: '2.5rem',
            color: 'var(--text-dark)',
            marginBottom: '25px',
            fontWeight: '700'
        },
        p: {
            fontSize: '1.1rem',
            lineHeight: '1.7',
            color: 'var(--text-grey)',
            marginBottom: '20px'
        },
        stats: {
            display: 'flex',
            gap: '40px',
            marginTop: '40px'
        },
        statItem: {
            textAlign: 'left'
        },
        statNumber: {
            display: 'block',
            fontSize: '3rem',
            fontWeight: '700',
            color: 'var(--gradient-cyan)',
            background: 'var(--gradient-bg)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            lineHeight: '1'
        },
        statLabel: {
            color: 'var(--text-dark)',
            fontWeight: '600',
            marginTop: '5px',
            display: 'block'
        }
    };

  return (
    <div style={{ backgroundColor: '#f9f9f9' }}>
        <div className="container" style={styles.container}>
            <div style={styles.flexContainer}>
                <div style={styles.imageSide}>
                    {/* Updated image tag */}
                    <img
                        src="/assets/about-us.png"
                        alt="tronixAI team collaborating in a modern office"
                        style={styles.image}
                    />
                </div>
                <div style={styles.contentSide}>
                    <h1 style={styles.h1}>Pioneering the Future of Integrated Tech</h1>
                    <p style={styles.p}>Founded with a vision to erase the boundaries between hardware, software, and physical infrastructure, tronixAI is a new breed of technology partner. We believe that true innovation happens at the intersection of disciplines.</p>
                    <p style={styles.p}>Our mission is to empower businesses and cities with intelligent, scalable, and sustainable solutions that drive real-world impact.</p>

                    <div style={styles.stats}>
                        <div style={styles.statItem}>
                            <span style={styles.statNumber}>3+</span>
                            <span style={styles.statLabel}>Core Disciplines</span>
                        </div>
                        <div style={styles.statItem}>
                            <span style={styles.statNumber}>100%</span>
                            <span style={styles.statLabel}>Innovation Focus</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default AboutUs;